<template>
  <div>
    <header>
      <b-dropdown
        id="dropdownu"
        right
        text="Editar Menú"
        variant="dark"
        size="sm"
        class="m-md-2 btn-edit"
        :class="{ ocultarClass: esHome }"
      >
        <b-dropdown-item v-b-modal="'bg-header'">
          <font-awesome-icon icon="fill-drip" />Editar Fondo
        </b-dropdown-item>
        <b-dropdown-item v-b-modal="'modal-links'">
          <font-awesome-icon icon="link" />Editar Links
        </b-dropdown-item>
      </b-dropdown>

      <div class="header-container" ref="header" :style="style">
        <div class="logo-container">
          <img
            @click="countClicks"
            src="@/assets/imgs/logo.png"
            class="animation-slide-l-r"
          />
          <p class="logo-text">Buró Contigo</p>
        </div>
        <div class="menu-container">
          <div class="link dropdown d-flex">
            <a href="#portada" v-smooth-scroll="{ duration: 2000 }">Inicio</a>
          </div>
          <div
            class="link dropdown d-flex"
            v-for="(link, index) in links"
            :key="index"
          >
            <div v-if="link.eslink === 1">
              <a
                @click="insertarLectura(link.id)"
                :href="'#' + link.id"
                v-smooth-scroll="{ duration: 2000 }"
                >{{ link.seccion }}</a
              >
              <b-badge
                variant="danger"
                v-b-modal.modal-delete-link
                v-on:click="linkActual = index"
                :class="{ ocultarClass: esHome }"
                class="ml-2"
              >
                <font-awesome-icon icon="times" />
              </b-badge>
            </div>
            <div v-else>
              <a href="#dropdown">{{ link.seccion }}</a>
              <b-badge
                variant="danger"
                v-b-modal.modal-delete-link
                v-on:click="linkActual = index"
                :class="{ ocultarClass: esHome }"
                class="ml-2"
              >
                <font-awesome-icon icon="times" />
              </b-badge>
              <div class="dropdown-content">
                <div
                  v-for="(sublink, index2) in link.secciones"
                  :key="index2"
                  style="position: relative;"
                >
                  <b-badge
                    variant="danger"
                    v-on:click=";(linkActual = index), deleteLink(index2, true)"
                    :class="{ ocultarClass: esHome }"
                    class="clic"
                    style="position: absolute; top: 0; right: 0"
                  >
                    <font-awesome-icon icon="times" />
                  </b-badge>
                  <a
                    @click="insertarLectura(sublink.id)"
                    :href="'#' + sublink.id"
                    v-smooth-scroll
                    >{{ sublink.seccion }}</a
                  >
                </div>
                <a
                  href="#"
                  class="text-secondary"
                  v-on:click="linkActual = index"
                  v-b-modal="'modal-dropdown'"
                  :class="{ ocultarClass: esHome }"
                >
                  <font-awesome-icon icon="plus" />Agregar seccion
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!--Modal Agregar links al menú-->
    <b-modal
      id="modal-links"
      ref="modal"
      title="Editar Links"
      @show="resetModal"
      @hidden="resetModal"
      @ok="addLink"
      no-close-on-backdrop
    >
      <p class="my-4">Selecciona el tipo de link</p>
      <form ref="form" @submit.stop.prevent="addLink">
        <b-form-group class="d-flex">
          <b-form-radio v-model="selected" name="some-radios" value="Link"
            >Link Simple</b-form-radio
          >
          <b-form-radio v-model="selected" name="some-radios" value="Dropdown"
            >Dropdown</b-form-radio
          >
        </b-form-group>
        <div v-if="selected === 'Link'">
          <b-form-group
            :state="nameState"
            label="Nombre"
            label-for="name-input"
            invalid-feedback="El nombre es requerido"
          >
            <b-form-input
              id="name-input"
              v-model="name"
              :state="validation"
              required
            ></b-form-input>
          </b-form-group>
          <!--Muestra las secciones disponibles-->
          <form ref="form" @submit.stop.prevent>
            <b-form-group label="Selecciona a donde redirige el link:">
              <b-form-radio-group
                id="radio-group"
                v-model="link"
                :state="nameState2"
                :options="secciones"
                name="radio-secciones"
                value-field="id"
                text-field="titulo"
                required
                invalid-feedback="El link es requerido"
              ></b-form-radio-group>
            </b-form-group>
          </form>
        </div>
        <div v-else>
          <b-form-group
            :state="nameState"
            label="Nombre"
            label-for="name-input"
            invalid-feedback="El nombre es requerido"
          >
            <b-form-input
              id="name-input"
              v-model="name"
              :state="nameState"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()"
          >Cancelar</b-button
        >
        <b-button size="sm" variant="success" @click="ok()">Guardar</b-button>
      </template>
    </b-modal>

    <!--Modal agregar secciones al dropdown-->
    <b-modal
      id="modal-dropdown"
      ref="modal"
      title="Agregar secciones al dropdown"
      @show="resetModal"
      @hidden="resetModal"
      @ok="addDropdown"
      no-close-on-backdrop
    >
      <!--Muestra las secciones para agregar al dropdown-->
      <form ref="form">
        <b-form-group label="Agrega las secciones:">
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="selectedseccs"
            :options="secciones"
            name="flavour-1"
            value-field="id"
            text-field="titulo"
          ></b-form-checkbox-group>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()"
          >Cancelar</b-button
        >
        <b-button size="sm" variant="success" @click="ok()">Guardar</b-button>
      </template>
    </b-modal>

    <!--Modal para confirmar eliminar un link-->
    <b-modal
      @ok="deleteLink(linkActual, false)"
      id="modal-delete-link"
      title="Eliminar Link"
    >
      <div class="container">
        <p>¿Eliminar el Link?</p>
      </div>
    </b-modal>

    <!--Modal cambia el fondo del header-->
    <b-modal
      id="bg-header"
      ref="modal"
      size="sm"
      title="Cambiar fondo"
      no-close-on-backdrop
    >
      <!--Color sólido de fondo-->
      <div>
        <label for="type-color" class="font-weight-bold">Color de Fondo:</label>
        <b-form-input
          v-model="colorbg"
          id="type-color"
          type="color"
        ></b-form-input>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()"
          >Cancelar</b-button
        >
        <b-button size="sm" variant="success" @click="cambiarBG(colorbg)"
          >Guardar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Header',
  props: {
    esHome: Boolean
  },
  data() {
    return {
      name: '',
      selected: '',
      link: '',
      selectedseccs: [],
      secciones: [],
      linkActual: 0,
      subLinkActual: 0,
      nameState: null,
      nameState2: null,
      editar: true,
      links: '',
      colorbg: '',
      localRoot: [],
      clickCount: 0,
      currentURL: null
    }
  },

  created() {

    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    this.links = this.localRoot['componentes']['header']['links']
    this.secciones = this.localRoot['componentes']['secciones']
    this.colorbg = this.localRoot['componentes']['header']['bgcolor']
    // console.log(this.colorbg)
  },
  computed: {
    validation() {
      return this.name.length > 0
    },
    style() {
      return 'background-color: ' + this.colorbg + ';'
    }
  },

  methods: {
    countClicks() {
      console.log(this.clickCount)

      this.clickCount++
      if (this.clickCount >= 5) {
        console.log('inside Clickcount')

        this.$router.push('/buro')
      }
    },

    insertarLectura(titulo) {
      console.log(titulo)
      if (titulo === 'portada') return

         this.currentURL = window.location.href.split('/')
      let num = this.currentURL[this.currentURL.length - 1];
       console.log('num', num);
      let local_root = JSON.parse(window.localStorage.getItem('root'))
      let dated = local_root['detalles'][0]['fecha'].split('-')
      let mes = dated[1]
      let year = dated[0]
      console.log('año', year)
      console.log('mes', mes)
      axios
        .post('inserta_lectura.php', { titulo: titulo, mes: mes, year: year })
        .then(resp => {
          console.log(resp.data)
        })
        .catch(Error => {
          console.log(Error)
        })
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
      this.link = ''
      this.nameState2 = null
      this.selectedseccs = []
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.secciones = this.localRoot['componentes']['secciones']
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit2()
    },
    handleOk2(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      //this.handleSubmit2()h
    },

    addLink(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (!this.checkFormValidity()) {
        return
      }

      if (this.selected === 'Link') {
        this.links.push({ seccion: this.name, eslink: 1, id: this.link })
      } else {
        this.links.push({ seccion: this.name, eslink: 0, secciones: [] })
      }
      this.addToRoot()
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-links')
      })
    },
    addDropdown() {
      this.selectedseccs.forEach(section => {
        console.log(this.linkActual)
        this.links[this.linkActual].secciones.push({
          seccion: this.secciones[section].titulo,
          id: section
        })
        this.addToRoot()
      })
      this.$nextTick(() => {
        this.$bvModal.hide('modal-dropdown')
      })
    },
    deleteLink(link, sub) {
      if (this.links[this.linkActual].eslink == 0 && sub) {
        this.$delete(this.links[this.linkActual].secciones, link)
        console.log('dropdown')
        //console.log(this.links[this.linkActual].secciones)
      } else this.$delete(this.links, link)

      this.addToRoot()
    },
    cambiarBG(bgcolor) {
      this.$refs.header.style.backgroundColor = bgcolor
      this.localRoot.componentes.header.bgcolor = bgcolor
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.$nextTick(() => {
        this.$bvModal.hide('bg-header')
      })
    },
    //Metodo para agregar los componentes de header al root
    addToRoot() {
      this.localRoot.componentes.header.links = this.links
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    }
  }
}
</script>

<style scoped lang="scss">
$menu-h: 6em;
@font-face {
  font-family: 'avenir';
  src: url('/font/avenirlt.ttf');
}
a,
p {
  font-family: 'avenir' !important;
  font-weight: normal !important;
}

header {
  position: relative;
  grid-area: header;
  z-index: 100;
}

.header-container {
  display: grid;
  grid-template-columns: 40% 60%;
  grid-template-rows: 100%;
  /*width: 1300px;*/
  margin: 0 auto;
}

.logo-container {
  margin-left: 150px;
  width: 50%;
  height: $menu-h;
  display: grid;
  grid-template-columns: 30% 70%;
  grid-template-rows: 30% 70%;
}

.logo-container img {
  height: 4em;
  width: 240px;
  grid-row: 2 / 3;
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
}

.logo-text {
  font-family: futura;
  grid-row: 2 / 3;
  grid-column: 2 / 3;
  font-size: 26px;
  color: #3b58b8;
  align-self: center;
  font-family: 'avenir';
}

.menu-container {
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  padding-bottom: 20px;
}

.menu-container div:not(:last-child) {
  border-right: 1px #1d1d1d solid;
}

nav {
  display: flex;
  justify-content: space-around;
}

.link {
  padding: 5px 30px;
}

.link a {
  color: rgb(53, 53, 53);
  // font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
  font-weight: bolder;
  text-align: center;
  text-decoration: none;
  font-size: 17px;
}

.dropdown-content {
  display: none;
  position: absolute;
  top: 1.5em;
  margin-right: 50px;
  background-color: #f1f1f1;
  min-width: 180px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  color: #262626;
  font-family: 'avenir';
  font-weight: bold;
  padding: 8px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
  border-bottom: 1px #262626 solid;
  text-align: center;
}

.dropdown:hover .dropdown-content {
  display: block;
  background-color: rgba(255, 255, 255, 1);
}
.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: none !important;
}

.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 1.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
  opacity: 1 !important;
}

@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}

@font-face {
  font-family: 'avenir';
  src: url('/font/avenirlt.ttf');
}
</style>
